import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';

// project imports
import { getToken } from 'services/http';

// ==============================|| 登录守卫：未登录跳转到 /login ||============================== //

export default function RequireAuth({ children }) {
  const location = useLocation();
  if (!getToken()) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return children;
}

RequireAuth.propTypes = {
  children: PropTypes.node
};
